<template>
    <div id="promo_create" class="content-tab mktops-maincontent mktops-create">
    <component :is="step"></component>
</div>
</template>
<!-- <template>
  <v-app id="dashboard">
      <v-btn color="primary" @click="logout">Logout</v-btn>
  </v-app>
</template> -->
<script>
export default {
  name: 'promotion-create',
  created() {
    // this.$store.dispatch('pmcreate/getUnitMaster')
  },
  computed: {
    step (){
      return this.$store.getters['pmcreate/step']
    }
  },
  /* eslint-disable */
  components: {
    'step-1' : require('./create/step-1').default, 
    'step-2' : require('./create/step-2').default, 
    'step-3' : require('./create/step-3').default, 
  },
  /* eslint-disable */
}
</script>
